import get from 'lodash.get';
import {
  DOMAIN_PREFIX,
  LANGUAGE_VALUE,
} from '../../../../constants/staticPageConstants';
import { processURL } from '../../../../utils/static-pages/urlProcessor';
import { If } from '../../../Atoms/Conditionals';
import { UpTick } from '../../../Icons';
import { LANG_DATA } from '../language/dataset';
import { ISINGLE_POST } from '../types';
import { getLangText } from './utils';

interface ILANGUAGE_SWITCH_PROPS {
  isMultiLanguage: boolean;
  pageData: ISINGLE_POST;
  className: string;
}

export const LanguageSwitch = ({
  isMultiLanguage,
  pageData,
  className,
}: ILANGUAGE_SWITCH_PROPS): JSX.Element => {
  const { domain, linked_languages, language, permalink } = pageData;

  const pageLanguage = get(LANGUAGE_VALUE, language, 'English');
  const langData = get(LANG_DATA, pageLanguage, LANG_DATA.English);
  const prefix = DOMAIN_PREFIX[domain]?.host;
  if (!prefix) return <></>;
  return (
    <>
      <If condition={!!(isMultiLanguage && linked_languages.length > 0)}>
        <div className="group py-2.5 flex relative w-2/3 items-center cursor-pointer sm:w-full mx-6 sm:ml-0 md:mx-0 sm:mx-0">
          <p className="cursor-pointer text-s-14 w-max">
            {langData?.captionItem.switchTo}
          </p>
          <div className="group-hover:rotate-180 mx-2">
            <UpTick colorCode="#9092A3" />
          </div>
          <div className="absolute z-10 hidden group-hover:block bg-white w-40 top-9 shadow-lg rounded-md cursor-pointer">
            {linked_languages?.map((item, index) => {
              const lang =
                LANGUAGE_VALUE[item.language_id as keyof typeof LANGUAGE_VALUE];
              return (
                <a
                  href={`https://www.${prefix}/${processURL(
                    permalink,
                    lang,
                    domain
                  )}`}
                  className={`${className} font-medium hover:bg-grey-960 px-3 py-2 rounded-md block hover:text-blue-350 `}
                  key={index}
                >
                  {getLangText(item.language_id)}
                </a>
              );
            })}
          </div>
        </div>
      </If>
    </>
  );
};
